import React from 'react';
import { useTheme } from '@mui/material/styles';
import type { ThemedSvgProps } from '../../types';

const GamingPixelsBase: React.FC<ThemedSvgProps> = ({ color, size = 60, className }) => {
  const theme = useTheme();
  const fill = color || theme.palette.venue.gaming;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="presentation"
      className={className}
    >
      {/* Pixel 1 - large, full opacity */}
      <rect x="12" y="20" width="10" height="10" fill={fill} opacity={1.0} />

      {/* Pixel 2 - medium, tilted */}
      <rect
        x="55"
        y="10"
        width="8"
        height="8"
        fill={fill}
        opacity={0.8}
        transform="rotate(15 59 14)"
      />

      {/* Pixel 3 - small, faded */}
      <rect x="80" y="35" width="6" height="6" fill={fill} opacity={0.4} />

      {/* Pixel 4 - medium, tilted */}
      <rect
        x="30"
        y="55"
        width="8"
        height="8"
        fill={fill}
        opacity={0.7}
        transform="rotate(30 34 59)"
      />

      {/* Pixel 5 - large, mid opacity */}
      <rect x="70" y="65" width="10" height="10" fill={fill} opacity={0.6} />

      {/* Pixel 6 - small, tilted */}
      <rect
        x="15"
        y="78"
        width="5"
        height="5"
        fill={fill}
        opacity={0.5}
        transform="rotate(45 17.5 80.5)"
      />

      {/* Pixel 7 - medium */}
      <rect x="50" y="42" width="7" height="7" fill={fill} opacity={0.9} />

      {/* Pixel 8 - small, faded, tilted */}
      <rect
        x="88"
        y="80"
        width="4"
        height="4"
        fill={fill}
        opacity={0.3}
        transform="rotate(20 90 82)"
      />
    </svg>
  );
};

export const GamingPixels = React.memo(GamingPixelsBase);
